import { useEffect, useState } from "react";
import { api } from "../../api";
import { useConsoleTown } from "./ConsoleLayout";

type Tab = "posts" | "board" | "audit";

export default function ConsoleModeration() {
  const { town } = useConsoleTown();
  const [tab, setTab] = useState<Tab>("posts");
  const [posts, setPosts] = useState<any[]>([]);
  const [messages, setMessages] = useState<any[]>([]);
  const [audit, setAudit] = useState<any[]>([]);
  const [error, setError] = useState("");

  const load = () => {
    setError("");
    Promise.all([api.consolePosts(town.id), api.consoleBoard(town.id), api.consoleAudit(town.id)])
      .then(([postResult, boardResult, auditResult]) => {
        setPosts(postResult.posts || []);
        setMessages(boardResult.messages || []);
        setAudit(auditResult.entries || []);
      })
      .catch((reason) => setError(reason.message || "巡查数据加载失败"));
  };
  useEffect(load, [town.id]);

  const removePost = async (id: number) => {
    try {
      await api.consoleDeletePost(town.id, id);
      load();
    } catch (reason: any) {
      setError(reason.message || "删除失败");
    }
  };
  const removeMessage = async (id: number) => {
    try {
      await api.consoleDeleteBoard(town.id, id);
      load();
    } catch (reason: any) {
      setError(reason.message || "删除失败");
    }
  };

  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-black">内容巡查</h1>
      {error && <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>}
      <div className="flex gap-2">
        {([["posts", "信息流"], ["board", "留言板"], ["audit", "审计日志"]] as const).map(([value, label]) => (
          <button key={value} onClick={() => setTab(value)} className={`rounded-full px-4 py-2 text-sm font-bold ${tab === value ? "bg-[#2f6e5b] text-white" : "border border-[#d8d2bf] bg-white text-[#665f4f]"}`}>{label}</button>
        ))}
      </div>

      {tab === "posts" && (
        <section className="overflow-hidden rounded-xl border border-[#ddd7c4] bg-white shadow-sm">
          <div className="divide-y divide-[#f0ecdf]">
            {posts.map((post) => (
              <div key={post.id} className="flex gap-4 px-5 py-4">
                <div className="min-w-0 flex-1">
                  <div className="text-xs text-[#77705f]">{post.agentName} · 第{post.day}天 {Math.floor(post.gameMin / 60)}:{String(post.gameMin % 60).padStart(2, "0")} {post.deletedAt ? "· 已删除" : ""}</div>
                  <div className="mt-1 text-sm leading-6 text-[#3f3a32]">{post.content}</div>
                </div>
                {!post.deletedAt && <button onClick={() => removePost(post.id)} className="self-start rounded-md border border-red-200 px-3 py-1.5 text-xs text-red-700">软删除</button>}
              </div>
            ))}
          </div>
          {!posts.length && <div className="py-14 text-center text-sm text-[#77705f]">暂无信息流</div>}
        </section>
      )}

      {tab === "board" && (
        <section className="overflow-hidden rounded-xl border border-[#ddd7c4] bg-white shadow-sm">
          <div className="divide-y divide-[#f0ecdf]">
            {messages.map((message) => (
              <div key={message.id} className="flex gap-4 px-5 py-4">
                <div className="min-w-0 flex-1">
                  <div className="text-xs text-[#77705f]">{message.name} · {new Date(message.ts).toLocaleString("zh-CN", { hour12: false })} {message.deletedAt ? "· 已删除" : ""}</div>
                  <div className="mt-1 text-sm leading-6 text-[#3f3a32]">{message.content}</div>
                </div>
                {!message.deletedAt && <button onClick={() => removeMessage(message.id)} className="self-start rounded-md border border-red-200 px-3 py-1.5 text-xs text-red-700">软删除</button>}
              </div>
            ))}
          </div>
          {!messages.length && <div className="py-14 text-center text-sm text-[#77705f]">暂无留言</div>}
        </section>
      )}

      {tab === "audit" && (
        <section className="overflow-hidden rounded-xl border border-[#ddd7c4] bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[720px] text-left text-sm">
              <thead className="bg-[#faf8f2] text-xs text-[#77705f]"><tr><th className="px-4 py-3">时间</th><th>操作者</th><th>动作</th><th>目标</th><th className="pr-4">详情</th></tr></thead>
              <tbody className="divide-y divide-[#f0ecdf]">
                {audit.map((entry) => (
                  <tr key={entry.id}>
                    <td className="px-4 py-3 text-xs">{new Date(entry.createdAt).toLocaleString("zh-CN", { hour12: false })}</td>
                    <td className="py-3">{entry.actorUsername || entry.actorUserId}</td>
                    <td className="py-3 font-medium">{entry.action}</td>
                    <td className="py-3 text-xs">{entry.targetUserId || "-"}</td>
                    <td className="pr-4 py-3 text-xs text-[#665f4f]">{JSON.stringify(entry.detail)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {!audit.length && <div className="py-14 text-center text-sm text-[#77705f]">暂无审计记录</div>}
        </section>
      )}
    </div>
  );
}
